// extracted by mini-css-extract-plugin
export var redoItem = "_ov-1";
export var redoTrigger = "_ov-0";